var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6407 20.5938L29.6173 28.617L21.594 36.6402",
    stroke: "#F25524",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5166 20.4834L36.7141 36.6807",
    stroke: "#F25524",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9072 49.0435C38.1897 49.9863 48.1003 41.6043 49.0431 30.3218C49.9859 19.0393 41.6039 9.1287 30.3214 8.18589C19.0389 7.24309 9.12832 15.6251 8.18551 26.9076C7.24271 38.1901 15.6247 48.1007 26.9072 49.0435ZM26.4076 55.0227C40.9923 56.2414 53.8035 45.4061 55.0223 30.8214C56.241 16.2367 45.4058 3.42548 30.821 2.20673C16.2363 0.987988 3.4251 11.8232 2.20635 26.408C0.987607 40.9927 11.8229 53.8039 26.4076 55.0227Z",
    fill: "#F25524"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.a75cf6581627f7cd3efa7c223994a504.svg";
export { ForwardRef as ReactComponent };